<template>
    <div class="pending-trx-account-cell" :title="accountDescription">
        <span v-if="!subAccountUuid">{{ accountDescription }}</span>
        <sub-account-link v-else-if="subAccountUuid" :uuid="subAccountUuid" class="text-primary">
            <i class="inline-block -mb-[1px]" :class="subAccountIcon"/>
            {{ subAccountName }}
        </sub-account-link>
        <template v-if="bankAccountNumber">
            <span> - {{ formatBankAccountNo(bankAccountNumber as string) }}</span>
        </template>
    </div>
</template>

<script setup lang="ts">

import {computed, provide} from 'vue'
import {CUSTOMER_ACCOUNT_NO} from '@/bookkeeping-account/accountTypes'
import {findAccountByNo} from '@/bookkeeping-account/bookkeepingAccount.service'
import SubAccountLink from '@/subaccount/components/SubAccountLink.vue'
import {ExtendedPendingTransaction} from '@/pending-transaction/pendingTransaction.types'
import {formatBankAccountNo} from './bank-account.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: ExtendedPendingTransaction,
            isCredit: Boolean,
            context: {
                panelId: Number,
                panelPathSegment: String
            },
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params.data as ExtendedPendingTransaction
})

const accountNo = computed(() => props.params?.isCredit ? transactionLine.value.creditAccountNo : transactionLine.value.debitAccountNo)

const isCustomer = computed(() => accountNo.value === CUSTOMER_ACCOUNT_NO)

const accountDescription = computed(() => {
    if (!accountNo.value) return ''
    return findAccountByNo(accountNo.value)?.name
})

const bankAccountNumber = computed(() => props.params?.isCredit ? transactionLine.value.creditBankAccountNumber : transactionLine.value.debitBankAccountNumber)
const subAccountUuid = computed(() => props.params?.isCredit ? transactionLine.value.creditSubAccountUuid : transactionLine.value.debitSubAccountUuid)
const subAccountName = computed(() => props.params?.isCredit ? transactionLine.value.creditSubAccountName : transactionLine.value.debitSubAccountName)

const subAccountIcon = computed(() => {
    if (!subAccountUuid.value) return ''
    return isCustomer.value ? 'i-ph-user' : 'i-ph-factory'
})

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.pending-trx-account-cell {
    @apply truncate;
}
</style>